import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Dropdown, Flex } from 'ui';
import moment from '../../utils/cops-moment';

const ViewFlex = styled(Flex)`
  margin-left: 20px;
  flex-flow: row nowrap;
  font-size: 13px;
  height: 34px;
`;

const Title = styled.p`
  padding-top: 8px;
`;

const StyledDropdown = styled(Dropdown)`
  margin-left: 10px;
  width: 125px;
`;

const PeriodDropdown = ({
  intl,
  updatePeriod,
  activePeriod,
  isLoadingPeriods = false,
  boardData,
}) => {
  const [periodValue, setPeriodValue] = useState();

  const handlePeriodChange = (id) => {
    if (id !== activePeriod?.id) {
      setPeriodValue(id);
      updatePeriod(id);
    }
  };

  useEffect(() => {
    if (activePeriod?.id) {
      setPeriodValue(activePeriod.id);
      moment.updateLocale(
        moment.locale() || 'en',
        {
          weekStart: activePeriod?.parameters?.startOfWeek,
        },
      );
    }
  }, [activePeriod?.id]);

  const getDropdownValue = () => {
    if (isLoadingPeriods) {
      return intl.formatMessage({ id: 'worklist.filters.DATA_LOADING' });
    }
    return null;
  };

  return (
    <ViewFlex>
      <Title>
        <FormattedMessage id='worklist.filters.RANGE' />
        {':'}
      </Title>
      <StyledDropdown
        placeholder={intl.formatMessage({
          id: 'worklist.filters.NO_LABEL',
        })}
        dropdownMatchSelectWidth={false}
        onSelect={handlePeriodChange}
        values={boardData?.views || []}
        disabled={isLoadingPeriods}
        valueLabel='description'
        valueKey='id'
        loading={isLoadingPeriods}
        value={getDropdownValue() || periodValue}
        data-test-id='pb-period-dropdown'
      />
    </ViewFlex>
  );
};

PeriodDropdown.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
  isLoadingPeriods: PropTypes.bool,
  updatePeriod: PropTypes.func,
  activePeriod: PropTypes.object,
  boardData: PropTypes.object,
};

export default injectIntl(PeriodDropdown);
